import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Estimated euro payout for kWh */
export function kwhToEuro(kwh: number) {
  return ((kwh * 0.5 * 183 * 3.6) / 1000) * 0.75 * 0.4;
}
